var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7908 4.235C25.6655 3.74383 25.4102 3.2938 25.0507 2.93037C24.6912 2.56694 24.2403 2.30298 23.7435 2.16514C21.9283 1.73047 14.6677 1.73047 14.6677 1.73047C14.6677 1.73047 7.40712 1.73047 5.59197 2.20654C5.09517 2.34437 4.64427 2.60834 4.28479 2.97177C3.92532 3.3352 3.67001 3.78523 3.54464 4.27639C3.21245 6.08292 3.04995 7.91552 3.0592 9.75117C3.04736 11.6006 3.20986 13.4472 3.54464 15.2673C3.68285 15.7432 3.94388 16.1762 4.30252 16.5242C4.66116 16.8723 5.10528 17.1238 5.59197 17.2544C7.40712 17.7305 14.6677 17.7305 14.6677 17.7305C14.6677 17.7305 21.9283 17.7305 23.7435 17.2544C24.2403 17.1166 24.6912 16.8526 25.0507 16.4892C25.4102 16.1257 25.6655 15.6757 25.7908 15.1845C26.1205 13.3916 26.2829 11.573 26.2763 9.75117C26.2881 7.9017 26.1256 6.05512 25.7908 4.235Z",
    fill: "#B08C3D",
    stroke: "#B08C3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2932 13.1356L18.3613 9.75141L12.2932 6.36719V13.1356Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoActive);
export default __webpack_public_path__ + "static/media/video-active.6d826ae49891447499047dc06575a962.svg";
export { ForwardRef as ReactComponent };